import React from "react";
import { Step } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./progress.css";

const Progress = ({
  activeStep,
  demoVersion,
  onPrevious,
  onNext,
}) => {
  const steps = [
    { label: "Names" },
    { label: "Countdown" },
    { label: "Family" },
    { label: "Cover" },
    { label: "More" },
  ];

  const currentStep = steps[activeStep];

  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === steps.length - 1;

  return (
    <div
      className="progress-container"
      style={{
        marginTop: demoVersion ? "12px" : "12px",
      }}
    >

      {/* Sub-step navigation */}
      <div className="progress-sub-navigation">

        <button
          type="button"
          className="progress-nav-arrow"
          onClick={onPrevious}
          disabled={isFirstStep}
          aria-label="Previous step"
        >
          <ArrowBackIosIcon />
        </button>


        <div className="progress-current-step">
          <span className="progress-step-count">
            {activeStep + 1} of {steps.length}
          </span>

          <span className="progress-dot">·</span>

          <span className="progress-step-name">
            {currentStep.label}
          </span>
        </div>


        <button
          type="button"
          className="progress-nav-arrow"
          onClick={onNext}
          disabled={isLastStep}
          aria-label="Next step"
        >
          <ArrowForwardIosIcon />
        </button>

      </div>


      {/* Progress timeline */}
      <div className="progress-steps">

        {steps.map((item, index) => (
          <Step
            key={index}
            active={activeStep === index}
            completed={activeStep >= index}
          >
            <div className="progress-step-item">

              <div
                className={`progress-circle ${
                  activeStep >= index ? "completed" : ""
                }`}
              >
                {activeStep >= index ? "✓" : index + 1}
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`progress-line ${
                    activeStep > index ? "completed" : ""
                  }`}
                />
              )}

              <div className="progress-label">
                {item.label}
              </div>

            </div>
          </Step>
        ))}

      </div>

    </div>
  );
};

export default Progress;